<script setup lang="ts">
const searchStore = useSearchStore()
</script>

<template>
  <div class="search-results">
    <!-- <SearchResultCreator :show-more-button="true" :compact-mode="true" /> -->
    <!--    <NovaSearchResultGroup
      :search-item-type="'creator'"
      :items="searchStore.all.creators"
    />-->
    <NovaSearchResultGroup
      :search-item-type="'user'"
      :items="searchStore.all.users"
    />

    <!-- TODO: 앱 버전 릴리즈를 위해 기능 숨김 -->
    <!--    <NovaSearchResultGroup
      v-if="!(appStore.isApp || appStore.envMode === 'production')"
      :search-item-type="'premium'"
      :items="searchStore.all.novaPlusPost"
    />-->

    <NovaSearchResultGroup
      :search-item-type="'post'"
      :items="searchStore.all.post"
    />

    <NovaSearchResultGroup
      :search-item-type="'comment'"
      :items="searchStore.all.comment"
    />

    <NovaSearchResultGroup
      :search-item-type="'hash'"
      :items="searchStore.all.hash"
    />
  </div>
</template>

<style lang="scss" scoped>
.search-results {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
  flex: 20px;
  width: 100%;
  padding-bottom: 24px;

  @include mobile {
    padding: 0 10px 24px;
  }
}
</style>
